<template>
    <p  class="payment-meta__amount">
        {{amount}}₽
        <span>({{ amountUSD }}$)</span>
    </p>
</template>
<script setup lang="ts">
import {PropType} from "vue";

defineProps({
    amount: {
        type: [Number, null] as PropType<number | null>,
        required: true
    },
    amountUSD: {
        type: [Number, null] as PropType<number | null>,
        required: true
    }
});
</script>

<style lang="scss">
.payment-meta__amount {
    font-size: 12px;
    line-height: 14.4px;
    font-weight: 500;
    color: var(--grey2);
    background: none !important;
}
</style>
